import { GeneralTable } from "@/shared/components/ui";
import { useCheckPermissionsArray, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Grid, IconButton, Tooltip } from "@mui/material";
import {
  EstadoProspectoEnum,
  ROUTER_PATHS,
  TABLE_CONSTANTS,
} from "@/shared";
import { ISolicitudCanje } from "@/shared/interfaces";
import { Edit } from "@mui/icons-material";
import { useTableColumnsMarketing } from "@/shared/hooks/useTableColumnsMarketing";
import { useNavigate } from "react-router-dom";
import { PermissionsEnum } from "@/auth/interfaces";
import { useFetchSolicitudCanje } from "@/shared/actions/erp/marketing";

interface TableSolucionSolicitudCanjeProps {
  showCustomActionBtnSpace?: boolean
  enableEditing?: boolean
  estado_prospecto?: EstadoProspectoEnum
}

export default function TableSolucionSolicitudCanje({
  showCustomActionBtnSpace = true,
  enableEditing = true,

}: TableSolucionSolicitudCanjeProps) {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_solicitudcanje,
    PermissionsEnum.api_change_solicitudcanje
  ]);

  const navigate = useNavigate()


  ///* Hooks
  const {
    ColumnsSolicitudCanje
  } = useTableColumnsMarketing();

  const {
    pagination,

    setPagination,
  } = useTableFilter();

  const { pageIndex } = pagination;

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { isLoading, data: SolicitudCanjeData, isRefetching } =
    useFetchSolicitudCanje({
      page: pageIndex + 1,
      ...filterObject,
      filterByState: false
    });

  // const {
  //   data: SolicitudCanjeData,
  //   isLoading,
  //   isRefetching
  // } = useFetchGetfactibilidadCorporativos({
  //   page: pageIndex + 1,
  //   ...filterObject,
  //   filterByState: false,
  //   solicitud_canje_isnull: false ,
  // })





  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>

        <Grid item xs={12}>
          <GeneralTable<ISolicitudCanje>
            columns={ColumnsSolicitudCanje}
            data={SolicitudCanjeData?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            ///* search
            enableGlobalFilter={false}
            enableSorting={false}
            // onGlobalFilterChange={setGlobalFilter}
            ///* pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={SolicitudCanjeData?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

            // crud
            canEdit={false}
            enableEditing={enableEditing}
            showCustomActionBtnSpace={showCustomActionBtnSpace}
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}

            customActionBtnSpace={(value) => {
              return (
                <Grid container>
                  <Grid item >
                    {
                      value?.factibilidad_corporativa_data
                      &&value?.factibilidad_corporativa_data?.preaprobado_inventario?
                        <Tooltip title={'Revisar Factibilidad'} placement="top">
                          <IconButton
                            onClick={() => {
                              navigate(ROUTER_PATHS.marketing.solucionSolicitudesCanjeEventoNav + "/" + value?.factibilidad_corporativa_data?.id_factibilidad_coorporativa)
                            }
                            }
                          >
                            <Edit />
                          </IconButton>
                        </Tooltip>
                        : null
                    }
                  </Grid>
                </Grid>
              )
            }
            }
          />
        </Grid>
      </Grid>


    </>

  );



}